import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-cookies-modal',
  templateUrl: './cookies-modal.component.html',
  styleUrls: ['./cookies-modal.component.scss']
})
export class CookiesModalComponent implements OnInit {

  constructor(
    public seo: SeoService,
    public dialogRef: MatDialogRef<CookiesModalComponent>
  ) { }

  ngOnInit(): void {
  }


  closeModal(opcion) {
    this.seo.cookiesAcepted = opcion;
    localStorage.setItem('cookiesAcepted', opcion);
    this.dialogRef.close();
  }
}
